import SquareIcon from '@mui/icons-material/Square';
import Checkbox from '@material-ui/core/Checkbox';
import { IPerformanceCompetenciesOptions } from '../../../interfaces/PerformanceEvaluationQualification.interface';


type CheckboxQualificationProps ={
    option:IPerformanceCompetenciesOptions,
    addQualification:(event:any,idCompetencies:number)=> void
    idCompetencies:number
    isChecked?: boolean,
    disabled?: boolean,
  }

 const CheckboxQualification = ({option,addQualification,idCompetencies,isChecked=false, disabled=false}:CheckboxQualificationProps) => {
  const{idQual,qualification,description}=option  
  return (
    <div className='containerCheckbox'>
       <Checkbox     
        id={idQual.toString()}         
        name={qualification}       
        checked={isChecked}
        disabled={disabled}
        onClick={(event)=>addQualification(event,idCompetencies)}
        checkedIcon={        
            <SquareIcon sx={{  
            background: 'radial-gradient(#979797 10px 100%,  #ffffff 100%)',
            color: "#fabb00", 
            stroke: "#ffffff",
            strokeWidth: 2 
            }}        
             />
          }         
       />
      <div className='infoQualification'>
        <div className='qualificationCheckbox'>{qualification} </div>
        <div className='descriptionCheckbox'>{description} </div>
      </div>  


    </div>
  )
}

export default CheckboxQualification